import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';

interface Params {
  clientId: string;
  accountId: string;
}

const approveReview = ({ clientId, accountId }: Params) =>
  authFetch('/Adviser/ManagedAccountInvestigation/Approve', {
    method: 'POST',
    ...httpBodyOptions(
      {
        clientId,
        managedAccountId: accountId,
      },
      true,
    ),
  });

export const useApproveReviewMutation = () => {
  return useMutation(approveReview);
};
